<template>
  <v-row class="pa-2" :style="style">
    <v-col class="" :class="h1Class + className">{{ name }}</v-col>
    <v-col class="font-weight-bold" :class="h1Class + className + alignText">{{
      stop_name
    }}</v-col>
    <v-col class="text-right hidden-sm-and-down" :class="className"
      ><TimeNow :timeZone="timeZone"
    /></v-col>
  </v-row>
</template>

<script>
import TimeNow from "./TimeNow.vue";
export default {
  inject: ["h1Class"],
  components: { TimeNow },
  props: {
    name: String,
    timeZone: String,
    stop_name: String,
    header_background_color: String,
    header_font_color: String,
  },
  computed: {
    alignText() {
      const { name } = this.$vuetify.breakpoint;
      let className = " ";
      switch (name) {
        case "xs":
          className = " text-right";
          break;
        case "sm":
          className = " text-right";
          break;
        case "md":
        case "lg":
        case "xl":
      }
      return className;
    },
    className() {
      const { name } = this.$vuetify.breakpoint;
      let className = " ma-5";
      switch (name) {
        case "xs":
          className = " ma-3";
          break;
        case "sm":
        case "md":
        case "lg":
        case "xl":
      }
      return className;
    },
    style() {
      const { name } = this.$vuetify.breakpoint;
      console.log(name);
      let height = 150;
      switch (name) {
        case "xs":
          height = 100;
          break;
        case "sm":
        case "md":
        case "lg":
        case "xl":
      }
      return `background-color:${this.header_background_color} ; color: ${this.header_font_color}; height: ${height}px`;
    },
  },
};
</script>

<style scoped></style>
